import { render, staticRenderFns } from "./formCarteiraCobranca.vue?vue&type=template&id=87cfbbc6&scoped=true"
import script from "./formCarteiraCobranca.vue?vue&type=script&lang=js"
export * from "./formCarteiraCobranca.vue?vue&type=script&lang=js"
import style0 from "./formCarteiraCobranca.vue?vue&type=style&index=0&id=87cfbbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cfbbc6",
  null
  
)

export default component.exports